import React, { useEffect } from 'react';
type PixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push?: PixelFunction;
  loaded?: boolean;
  version?: string;
};
interface MetaPixelWindow extends Window {
  fbq?: PixelFunction;
  _fbq?: PixelFunction;
}
const PIXEL_ID = '1382687990446575';
export function MetaPixel() {
  useEffect(() => {
    let timer: number;
    let initialized = false;
    const initPixel = () => {
      if (initialized) return;
      initialized = true;
      const pixelWindow = window as MetaPixelWindow;
      if (pixelWindow.fbq) {
        pixelWindow.fbq('track', 'PageView');
        return;
      }
      const fbq = ((...args: unknown[]) => {
        if (fbq.callMethod) {
          fbq.callMethod(...args);
        } else {
          fbq.queue.push(args);
        }
      }) as PixelFunction;
      fbq.queue = [];
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      pixelWindow.fbq = fbq;
      pixelWindow._fbq = fbq;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      script.id = 'meta-pixel-script';
      const firstScript = document.getElementsByTagName('script')[0];
      if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
      } else {
        document.head.appendChild(script);
      }
      fbq('init', PIXEL_ID);
      fbq('track', 'PageView');
    };

    // Delay pixel loading until user interaction or 4 seconds to improve initial page load performance
    const load = () => {
      initPixel();
      window.removeEventListener('scroll', load);
      window.removeEventListener('mousemove', load);
      window.removeEventListener('touchstart', load);
      if (timer) window.clearTimeout(timer);
    };
    window.addEventListener('scroll', load, {
      passive: true
    });
    window.addEventListener('mousemove', load, {
      passive: true
    });
    window.addEventListener('touchstart', load, {
      passive: true
    });
    timer = window.setTimeout(load, 4000);
    return () => {
      window.removeEventListener('scroll', load);
      window.removeEventListener('mousemove', load);
      window.removeEventListener('touchstart', load);
      if (timer) window.clearTimeout(timer);
    };
  }, []);
  return <noscript data-id="element-137" data-mp="2vw6gxj8lbb6k">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-138" data-mp="2vwokz21hutp1" />
    </noscript>;
}